import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { TextInput } from '@prosolve/common-components-ui'
import useIsMobileView from "../../../hooks/useIsMobileView";
import StudentPlacementBar from './StudentPlacementBar';
import { getStudentPlacement } from '../studentPlacement';

const Option = styled.div`
  font-size: 14px;
  padding: 15px 20px;
  color: #ffffff;
  text-align: center;
  border-radius: 5px;
  margin-bottom: 1px;
  display: flex;
  ${props => props.$isOptionRow ? `
    flex-direction: row;
    align-items: center;
    width: 100%;
    column-gap: 20px;
  ` : `
    flex-direction: column;
    align-items: center;
  `}
  ${props => (!props.$isOptionRow && !props.$isMobileView) ? 'flex: 1 1 0; min-width: 140px;' : ''}
`;

export default ({
  questionId,
  answers,
  setAnswers,
  options = [],
  isColumn,
  largeFonts,
  extraLargeFonts,
  hasInvalidMark,
  requiredStudentTotal
}) => {
  const isMobileView = useIsMobileView();

  const [hasInitialized, setHasInitialized] = useState(false)

  useEffect(() => {
    setHasInitialized(true)
  }, [])

  const answerObj =  answers[questionId] || {};
  const {
    answerArray = []
  } = answerObj;

  const onUpdateAnswer = (id, val) => {
    // We want to prevent this from being called on inital render
    if (hasInitialized) {
      let updateAnswerArray = [...answerArray];

      const textValObj = updateAnswerArray.find(({ id: aId }) => aId === id);

      if (textValObj) {
        textValObj.answerText = val;
      } else {
        updateAnswerArray.push({ id, answerText: val })
      }

      const updateObj = { answerArray: updateAnswerArray }

      setAnswers({
        ...answers,
        [questionId]: updateObj
      })
    }
  }

  // Scales with the question font (24 -> 36 -> 48), so 16px base -> 1.5x -> 2x
  const optionFontSize = extraLargeFonts ? '32px' : largeFonts ? '24px' : '16px'
  const optionFontWeight = (extraLargeFonts || largeFonts) ? 'bold' : 'normal'

  // Mobile is too narrow for the image | text | input row, so stack inside the option instead
  const isOptionRow = isColumn && !isMobileView

  // TeacherPulseCheck with numberOfStudents: show placed-vs-total under the numeric inputs
  const { hasNumericOptions, placed } = getStudentPlacement({ answerOptions: options }, answerObj)
  const showPlacementBar = requiredStudentTotal !== undefined && hasNumericOptions

  const wrapperStyle = {
    display: 'flex',
    flexDirection: (isColumn || isMobileView) ? 'column' : 'row',
    justifyContent: 'center',
    // Stretch so every option is the same size and the inputs align with each other
    alignItems: (isColumn || (!isMobileView)) ? 'stretch' : 'center',
    flexWrap: (isColumn || isMobileView) ? 'nowrap' : 'wrap',
    columnGap: '10px',
    rowGap: '15px',
    position: 'relative'
  };

  return (
    <div style={wrapperStyle}>
      {
        options.map(({ id, image, number, answerOption, showText }) => {
          const textValObj = answerArray.find(({ id: aId }) => aId === id) || {};
          const { answerText = '' } = textValObj;
          return (
            <Option key={id} $isOptionRow={isOptionRow} $isMobileView={isMobileView}>
              {
                image &&
                <img
                  src={image}
                  alt="answer-option"
                  style={{
                    height: '200px',
                    maxWidth: '100%',
                    objectFit: 'contain',
                    marginBottom: isOptionRow ? '0px' : '20px',
                    flexShrink: 0
                  }}
                />
              }
              {
                showText && answerOption &&
                <div style={{
                  fontSize: optionFontSize,
                  fontWeight: optionFontWeight,
                  flex: isOptionRow ? 1 : 'none',
                  marginBottom: isOptionRow ? '0px' : '15px'
                }}>
                  {answerOption}
                </div>
              }
              <div style={
                isOptionRow
                  ? { width: '220px', flexShrink: 0, marginLeft: 'auto' }
                  : { marginTop: 'auto', width: '100%' }
              }>
                <TextInput
                  width='100%'
                  style={{ textAlign: 'center', fontSize: '16px' }}
                  value={answerText}
                  type={number ? 'number' : 'text' }
                  min={0}
                  onChange={val => onUpdateAnswer(id, val)}
                  placeholder=''
                />
              </div>
            </Option>
          )
        })
      }
      {
        /* Full-width so it drops to its own line in the wrapping row layout */
        showPlacementBar &&
        <div style={{ width: '100%', flexBasis: '100%', marginTop: '20px' }}>
          <StudentPlacementBar placed={placed} total={requiredStudentTotal} />
        </div>
      }
      {
        hasInvalidMark &&
        <div style={{ position: 'absolute', bottom: '-20px', left: '0px', fontStyle: 'italic', fontSize: '15px', color: hasInvalidMark ? '#ef0c0c' : 'inherit' }}>
          {'*Required'}
        </div>
      }
    </div>
  )
}
